import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appPreventPipes]',
})
export class PreventPipesDirective {
  constructor() {}

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    const value = input.value;
    input.value = value.replace(/\|/g, ''); // Replace pipes with an empty string
  }
}
